import {
  Button,
  Card as MuiCard,
  Container,
  Divider as MuiDivider,
  Grid,
  Typography,
  Drawer
} from '@mui/material'
import { spacing } from '@mui/system'
import styled from '@emotion/styled'

const Divider = styled(MuiDivider)(spacing)
const Card = styled(MuiCard)(spacing)

function UserInfoDialog({ visible, onClose, initialValues, title, closeText }) {
  if (initialValues == undefined) initialValues = {
    first_name: '',
    last_name: '',
    user_name: '',
    mobile: '',
    user_type: '',
    email: '',
    password: '',
    confirmPassword: '',
    address: '',
    role: '',
  }

  return (
    <div>
      <Drawer anchor="right" backdrop="static" variant="temporary" open={visible} onClose={onClose}>
        <Container style={{ padding: 10 }}>
          <Typography variant="h6" gutterBottom>
            {title}
          </Typography>
          <Divider spacing={6} />
          <Card style={{ paddingTop: 20, paddingLeft: 10 }}>
            <Grid container spacing={1}>
              <Grid item md={6}>
                <Typography style={{ fontSize: 14 }} gutterBottom>
                  First Name :
                </Typography>
              </Grid>
              <Grid item md={6}>
                <Typography style={{ fontSize: 14 }} gutterBottom>
                  {initialValues?.first_name}
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item md={6}>
                <Typography style={{ fontSize: 14 }} gutterBottom>
                  Last Name :
                </Typography>
              </Grid>

              <Grid item>
                <Typography style={{ fontSize: 14 }} gutterBottom>
                  {initialValues?.last_name}
                </Typography>
              </Grid>
            </Grid>

            <Grid container spacing={1}>
              <Grid item md={4}>
                <Typography style={{ fontSize: 14 }} gutterBottom>
                  Email :
                </Typography>
              </Grid>
              <Grid item md={8}>
                <Typography style={{ fontSize: 14 }} gutterBottom>
                  {initialValues?.email}
                </Typography>
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid item md={6}>
                <Typography style={{ fontSize: 14 }} gutterBottom>
                  User ID :
                </Typography>
              </Grid>
              <Grid item>
                <Typography style={{ fontSize: 14 }} gutterBottom>
                  {initialValues?.user_name}
                </Typography>
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid item md={6}>
                <Typography style={{ fontSize: 14 }} gutterBottom>
                  Account Status :
                </Typography>
              </Grid>
              <Grid item>
                <Typography style={{ fontSize: 14 }} gutterBottom>
                  {initialValues?.account_status}
                </Typography>
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid item md={6}>
                <Typography style={{ fontSize: 14 }} gutterBottom>
                  User Type :
                </Typography>
              </Grid>
              <Grid item>
                <Typography style={{ fontSize: 14 }} gutterBottom>
                  {initialValues?.user_type}
                </Typography>
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid item md={6}>
                <Typography style={{ fontSize: 14 }} gutterBottom>
                  Mobile :
                </Typography>
              </Grid>
              <Grid item>
                <Typography style={{ fontSize: 14 }} gutterBottom>
                  {initialValues?.mobile}
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item md={6}>
                <Typography style={{ fontSize: 14 }} gutterBottom>
                  Address :
                </Typography>
              </Grid>
              <Grid item>
                <Typography style={{ fontSize: 14 }} gutterBottom>
                  {initialValues?.address}
                </Typography>
              </Grid>
            </Grid>
          </Card>
          <Grid container spacing={6} style={{ paddingTop: 20, paddingLeft: 30 }}>
            <Grid item md={6}>
              <Button onClick={onClose} variant="contained" mt={3}>
                {closeText}
              </Button>
            </Grid>
          </Grid>
        </Container>
      </Drawer>
    </div>
  )
}

export default UserInfoDialog
